import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-loading-dialog',
  templateUrl: './loading-dialog.component.html',
  styleUrls: ['./loading-dialog.component.scss'],
})
export class LoadingDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<LoadingDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  isApp: boolean = true;
  loadingDialogMainText: string;

  ngOnInit(): void {
    if (this.data.hasOwnProperty('isApp')) {
      this.isApp = this.data.isApp;
    }
    this.loadingDialogMainText = this.isApp
      ? 'component.onboarding.loading-dialog.main'
      : 'component.onboarding.loading-dialog.main-library';
  }

  cancelbtn(): void {
    this.dialogRef.close();
  }
}
